import React from "react";

const HancockText = () => (
  <React.Fragment>
    Hancock fustager leveres fra bryggeriet med meget kort holdbarhed, regn med helt ned til kun 7-dages holdbarhed fra købsdato.
    Køb derfor ikke før de skal bruges. Men bestil gerne i god tid, men først med levering umidelbart før brug!
  </React.Fragment>
);

export default HancockText;